module.exports = __webpack_public_path__ + "img/wwq.679577b9.gif";